import Alert from '@ramsey-design-system/alert';
import Text from '@ramsey-design-system/text';
import { SuccessIcon } from '@ramsey-design-system/icons';

interface MatcherSuccessMessageProps {
  successMessage: string;
}

export function MatcherSuccessMessage({
  successMessage
}: Readonly<MatcherSuccessMessageProps>) {
  return (
    <Alert
      data-testid={'matcher-success-message'}
      role="status"
      aria-label="success message"
      className="mb-4"
      fullWidth={true}
      color={'neutral'}
      icon={SuccessIcon}
    >
      <Text>{successMessage}</Text>
    </Alert>
  );
}
